'use client';

import { Icon } from '@/components/ui/Icon/Icon';
import { motion } from '@/libs';

import { Button } from '../../ui';

type LogoutConfirmationProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export const LogoutConfirmation = ({ onConfirm, onCancel }: LogoutConfirmationProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="flex flex-col items-center gap-4"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.3, ease: 'easeOut' }}
        className="w-12 h-12 bg-error/20 rounded-full flex items-center justify-center"
      >
        <Icon.Logout width={28} height={28} className="text-error/75" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.3, ease: 'easeOut' }}
        className="text-center"
      >
        <h3 className="text-lg font-semibold text-foreground mb-2">Confirmar Logout</h3>
        <p className="text-sm text-muted-foreground">
          Tem certeza que deseja sair da sua conta?
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.3, ease: 'easeOut' }}
        className="flex gap-3 w-full"
      >
        <Button
          onClick={onCancel}
          variant="primary"
          className="flex-1 bg-foreground/25 h-12 text-foreground sm:hover:text-primary-foreground text-sm"
        >
          Cancelar
        </Button>

        <Button
          variant="secondary"
          onClick={onConfirm}
          className="flex-1 h-12 text-foreground hover:bg-error/10 hover:text-foreground/80 text-sm"
        >
          Sim, Sair
        </Button>
      </motion.div>
    </motion.div>
  );
};
